// extracted by mini-css-extract-plugin
module.exports = {"background":"footer-module--background--3J1e4","wrapper":"footer-module--wrapper--L9Ajd"};